var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00555 22C7.45504 22 6.98377 21.8042 6.59174 21.4125C6.19971 21.0208 6.0037 20.55 6.0037 20C6.0037 19.45 6.19971 18.9792 6.59174 18.5875C6.98377 18.1958 7.45504 18 8.00555 18C8.55606 18 9.02733 18.1958 9.41935 18.5875C9.81138 18.9792 10.0074 19.45 10.0074 20C10.0074 20.55 9.81138 21.0208 9.41935 21.4125C9.02733 21.8042 8.55606 22 8.00555 22ZM18.0148 22C17.4643 22 16.993 21.8042 16.601 21.4125C16.209 21.0208 16.0129 20.55 16.0129 20C16.0129 19.45 16.209 18.9792 16.601 18.5875C16.993 18.1958 17.4643 18 18.0148 18C18.5653 18 19.0366 18.1958 19.4286 18.5875C19.8206 18.9792 20.0166 19.45 20.0166 20C20.0166 20.55 19.8206 21.0208 19.4286 21.4125C19.0366 21.8042 18.5653 22 18.0148 22ZM7.15476 6L9.55698 11H16.5635L19.316 6H7.15476ZM6.20388 4H20.9675C21.3512 4 21.6431 4.17083 21.8433 4.5125C22.0435 4.85417 22.0519 5.2 21.8684 5.55L18.3151 11.95C18.1316 12.2833 17.8855 12.5417 17.5769 12.725C17.2683 12.9083 16.9305 13 16.5635 13H9.10657L8.00555 15H20.0166V17H8.00555C7.25486 17 6.68766 16.6708 6.30398 16.0125C5.92029 15.3542 5.90361 14.7 6.25393 14.05L7.60518 11.6L4.00185 4H2V2H5.25301L6.20388 4Z",
    fill: "#2A2E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.e64cac0d6335a473b7436c3fd10cf2e8.svg";
export { ForwardRef as ReactComponent };